import { render, staticRenderFns } from "./Ebixa.vue?vue&type=template&id=0fe710b0&scoped=true"
import script from "./Ebixa.vue?vue&type=script&lang=js"
export * from "./Ebixa.vue?vue&type=script&lang=js"
import style0 from "./Ebixa.vue?vue&type=style&index=0&id=0fe710b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe710b0",
  null
  
)

export default component.exports